import { Modal, ModalBody, ModalCloseButton, ModalContent, ModalHeader, ModalOverlay } from "@chakra-ui/react";
import { FunctionComponent } from "react";
import { Entity } from "../../../api/entities/entityApi";
import { Jurisdiction } from "../../../api/jurisdictions/jurisdictionApi";
import { EntityForm } from "./EntityForm";
import { MODAL_CONTENT_SIZING, MODAL_SIZING } from "../../../utils/constants";

interface EntityModalProps {
    show: boolean;
    onClose: () => void;
    rowData?: Entity;
    jurisdictions: Jurisdiction[];
    onSave?: (data: Entity) => void;
    clientId?: string;
}

export const EntityModal: FunctionComponent<EntityModalProps> = ({ show, onClose, rowData, jurisdictions, clientId }) => {
    return (
        <Modal isOpen={show} onClose={onClose} size={MODAL_SIZING} isCentered motionPreset="slideInBottom">
            <ModalOverlay />
            <ModalContent style={{ ...MODAL_CONTENT_SIZING }} overflowY="auto">
                <ModalHeader>{rowData ? "Edit Entity" : "Add Entity"}</ModalHeader>
                <ModalCloseButton />
                <ModalBody>
                    <EntityForm show={show} onClose={onClose} rowData={rowData} jurisdictions={jurisdictions} clientId={clientId} />
                </ModalBody>
            </ModalContent>
        </Modal>
    );
};
